import { Button } from "@/components/ui/button";
import { useT } from "@/glossary";

export const SkipPrompt = ({
  onKeepTrying,
  onSkip,
}: {
  onKeepTrying: () => void;
  onSkip: () => void;
}) => {
  const t = useT();
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 px-4">
      <p className="text-center text-muted-foreground">{t.prod.skipPrompt}</p>
      <div className="flex gap-3">
        <Button onClick={onKeepTrying}>{t.prod.keepTrying}</Button>
        <Button variant="danger" onClick={onSkip}>
          {t.prod.skipExercise}
        </Button>
      </div>
    </div>
  );
};
